module.exports = __webpack_public_path__ + "img/s-find-job.f739c1a2.svg";